export type OneSignalUser = Readonly<{
  id?: string | null;
  email?: string | null;
}>;
